import { jsxs as e, jsx as l } from "react/jsx-runtime";
import { getIconStyles as i } from "../styles.js";
const t = (C) => /* @__PURE__ */ e(
  "svg",
  {
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: i(C),
    children: [
      /* @__PURE__ */ e("g", { clipPath: "url(#clip0_3928_22218)", children: [
        /* @__PURE__ */ l(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 8.24609C12.4142 8.24609 12.75 8.58188 12.75 8.99609V12.4961C12.75 12.9103 12.4142 13.2461 12 13.2461C11.5858 13.2461 11.25 12.9103 11.25 12.4961V8.99609C11.25 8.58188 11.5858 8.24609 12 8.24609Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M12.75 14.9961C12.75 15.4103 12.4142 15.7461 12 15.7461C11.5858 15.7461 11.25 15.4103 11.25 14.9961C11.25 14.5819 11.5858 14.2461 12 14.2461C12.4142 14.2461 12.75 14.5819 12.75 14.9961Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M1.13348 9.27849C-0.367411 10.7794 -0.367411 13.2128 1.13348 14.7137L9.2863 22.8665C10.7872 24.3674 13.2206 24.3674 14.7215 22.8665L22.8743 14.7137C24.3752 13.2128 24.3752 10.7794 22.8743 9.27849L14.7215 1.12567C13.2206 -0.375223 10.7872 -0.375223 9.2863 1.12567L1.13348 9.27849ZM12 17.9961C15.3137 17.9961 18 15.3098 18 11.9961C18 8.68239 15.3137 5.99609 12 5.99609C8.68629 5.99609 6 8.68239 6 11.9961C6 15.3098 8.68629 17.9961 12 17.9961ZM12.75 8.99609C12.75 8.58188 12.4142 8.24609 12 8.24609C11.5858 8.24609 11.25 8.58188 11.25 8.99609V12.4961C11.25 12.9103 11.5858 13.2461 12 13.2461C12.4142 13.2461 12.75 12.9103 12.75 12.4961V8.99609ZM12.75 14.9961C12.75 15.4103 12.4142 15.7461 12 15.7461C11.5858 15.7461 11.25 15.4103 11.25 14.9961C11.25 14.5819 11.5858 14.2461 12 14.2461C12.4142 14.2461 12.75 14.5819 12.75 14.9961Z",
            fill: "currentColor"
          }
        )
      ] }),
      /* @__PURE__ */ l("defs", { children: /* @__PURE__ */ l("clipPath", { id: "clip0_3928_22218", children: /* @__PURE__ */ l("rect", { width: "24", height: "24", fill: "white" }) }) })
    ]
  }
);
export {
  t as DiamondAlertIcon
};
//# sourceMappingURL=DiamondAlertIcon.js.map
